import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Transaction } from '../models/transaction';

@Injectable({
    providedIn: 'root'
  })
  export class TransactionService extends BaseService {
    apiUrl = '/api/wallet/';
    constructor(private httpClient: HttpClient) {
      super();
    }
    getAllTransactions() {
        return this.httpClient.get<Transaction[]>(
          this.baseUrl + this.apiUrl + 'GetTransactions',
          this.getAuthHeader()
        );
      }
      
}